import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import MalattieService from "../../../../../services/MalattieService";
import Utils from "../../../../../utils/Utils";
import {withTranslation} from "react-i18next";
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli";
import $ from "jquery";

class Trasmissione extends Component {
    state = {

        trasmissione: {
            trasmissione: this.props.malattiePremal.includes(this.props.malattia)? "82*" : "",
            corretto: []
        },
        clicks: 0,
        listaTrasmissioni: [],
        select: null
    }


    constructor(props) {
        super(props);
        this.props.setTrasmissione(this.state.trasmissione)
        this.handleChangeTrasmissioni = this.handleChangeTrasmissioni.bind(this)
        this.creaSelect = this.creaSelect.bind(this);
        this.controlloData = this.controlloData.bind(this);
    }


    componentDidMount() {

        MalattieService.getTrasmissioni(this.props.malattia).then((data) => {
            let listaTrasmissioni = Utils.mapToArray(data.data);
            this.setState({listaTrasmissioni: listaTrasmissioni})

            if (this.props.segnalazioneDatiSpecificiCopia.datiSpecifici) {
                if (this.props.segnalazioneDatiSpecificiCopia.datiSpecifici.trasmissione) {

                    let trasmissione = this.props.segnalazioneDatiSpecificiCopia.datiSpecifici.trasmissione
                    this.setState({trasmissione: trasmissione})
                }
            }
            this.creaSelect();
        }).catch(() => {
            console.log("errore chiamata trasmissioni")
            this.creaSelect();
        });
        if (this.props.trasmissione) {
            let trasmissione = this.state.trasmissione;
            this.setState({trasmissione: trasmissione})
        }

        if (this.props.segnalazioneDatiSpecificiCopia.datiSpecifici && this.props.segnalazioneDatiSpecificiCopia.datiSpecifici.trasmissione) {
            let trasmissione = this.state.trasmissione
            let trasmissioneCopia = JSON.parse(JSON.stringify(this.props.segnalazioneDatiSpecificiCopia.datiSpecifici))
            trasmissione.trasmissione = trasmissioneCopia.trasmissione.trasmissione
            this.setState({trasmissione: trasmissione})
        }

        this.controlloData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let trasmissione = JSON.parse(JSON.stringify(this.state.trasmissione))
            let trasmissionePerBackend = Utils.removeFieldFromObject(trasmissione, "corretto")
            this.props.setTrasmissione(this.state.trasmissione, Utils.removeEmptyValueFromObject(trasmissionePerBackend))
        }
    }

    controlloData() {
        let trasmissione = this.state.trasmissione;
        trasmissione.corretto = []
        if (!trasmissione.trasmissione) trasmissione.corretto[0] = "Campo \"Tipo di trasmissione\" mancante";
        else trasmissione.corretto[0] = "";

        this.setState({trasmissione: trasmissione});

    }

    creaSelect() {

        let select = (<div className="row">
            <div className="col-lg-6">
                <p className={styles.testo}>{this.props.t("DatiSpecifici.Trasmissione.tipo")}<span
                    className={styles.mandatoryColor}>*</span></p>
                <SelectAutocomplete
                    id={0}
                    value={this.state.trasmissione.trasmissione === "82*"? "82" : this.state.trasmissione.trasmissione}
                    disabled={this.props.segnalazioneDatiSpecificiCopia.migrazione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                        this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                    onChange={this.handleChangeTrasmissioni}
                    functionMap={this.state.listaTrasmissioni.map((oggetto) => {
                        return (<option value={oggetto.codiceTrasmissione}style={{backgroundColor:'white'}}>{oggetto.descrizioneTrasmissione}</option>)
                    })}
                    addclass={!this.props.segnalazioneDatiSpecificiCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.malattia) && this.state.trasmissione.trasmissione === "82*"? 'select-yellow' : !this.props.segnalazioneDatiSpecificiCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                /></div>
        </div>)

        this.setState({select: select})
    }

    handleChangeTrasmissioni(event) {

        let trasmissione = this.state.trasmissione
        trasmissione.trasmissione = event.target.value;

        this.setState(
            {trasmissione: trasmissione},
            () => {
                $(function () {
                    $('.selectpicker').selectpicker('refresh');
                });
                this.creaSelect();
                this.controlloData();
            }
        );

    }

    render() {

        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{this.props.t("DatiSpecifici.Trasmissione.titolo")}</h6>
                <hr className={styles.hr}></hr>
                <div className={"container"}>
                    {this.state.select}
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(Trasmissione)
